// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivePlan_wrapper__YhCw5","title":"ActivePlan_title__zNCKq","allPlan":"ActivePlan_allPlan__gRI9b"};